<template>
  <div v-if="!isActiveSoloCarta">
    <v-dialog
      v-if="checkQR"
      v-model="dialog"
      justify="center"
      persistent
      max-width="600px"
    >
      <v-card>
        <br />
        <v-card-text class="text-center">
          <v-alert
            v-if="!confirmQR || !qrValid"
            class="mt-5"
            type="error"
            outlined
            prominent
          >
            {{ $t("modal.pleaseScanAValidQRCode") }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-btn text small @click="closeQrValidationModal">
                {{ $t("common.close") }}
              </v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebaseMixin from "@/mixins/firebase/firebaseMixin.js";
import { getQrZoneById } from "@/collections/qrZone";
import { getQRByTable } from "@/collections/qrs";
import { userCartCollection } from "@/collections/userCart";

const NO_QR = "NO QR";
const ROUTE_RECEIPT = "receipt";
const ROUTE_RECENT = "recent";

export default {
  name: "QrValidationModal",
  props: ["checkQR", "isAdmin"],
  mixins: [firebaseMixin],
  data() {
    return {
      dialog: false,
      validQrSaved: false,
      confirmQR: false,
      selectLabelQR: this.$t("modal.selectTheQRCodeOfTheTable"),
      qrCollection: [],
      qrValid: false
    };
  },
  computed: {
    activesQR() {
      return this.$store.state.activesQR;
    },
    cartIsEmpty() {
      return this.$store.state.cart === 0;
    }
  },
  mounted() {
    setTimeout(() => {
      this.validateAndSaveQR();
    }, 500);
  },
  methods: {
    validateAndSaveQR() {
      // query qr
      let queryQR = this.$route.query.qr;
      // from local
      let localQR = this.isAdmin
        ? this.$store.state.adminTableQR
        : this.$store.state.tableQR;
      if (!queryQR) {
        // set valid local QR if available
        if (this.isValidQr(localQR) && !this.cartIsEmpty) {
          this.updateQR(localQR);
          return;
        }
        this.setTableNoQR();
        this.dialog = true;
        return;
      }

      let isValidQr = this.isValidQr(queryQR);
      if (isValidQr) {
        if (localQR === queryQR && !this.cartIsEmpty) {
          return;
        }
        this.updateQR(queryQR);
        return;
      }
      this.setTableNoQR();
      this.dialog = true;
    },
    isValidQr(queryQR) {
      return this.activesQR.find(x => x.table === queryQR);
    },
    async updateQR(queryQR) {
      let selectedQR = queryQR;
      let valid = this.qrIsValid(selectedQR);
      if (valid) {
        this.qrValid = true;
        this.isAdmin
          ? this.$store.commit("setAdminTableQR", selectedQR)
          : this.$store.commit("setTableQR", selectedQR);
        if (!(await this.isDirectPayment(selectedQR))) {
          this.onGetUserCartShared(selectedQR, this.isAdmin);
        }
        this.confirmQR = true;
        this.dialog = false;
      }
    },
    async isDirectPayment(qr) {
      try {
        let table = await getQRByTable(qr);
        if (table) {
          let qrZone = await getQrZoneById(table.zone_id);
          return qrZone.acceptDirectPayment === true;
        }
        return false;
      } catch (error) {
        this.setlogError(
          "get_qr_by_table/get_qr_zone_by_id",
          "Obtained error message in isDirectPayment()",
          error.stack,
          this.$options.name
        );
        return false;
      }
    },
    onGetUserCartShared(selectedQR, isAdmin) {
      if (isAdmin) {
        return;
      }

      let $store = this.$store;

      // This query can remain in the component itself, because a listener
      // https://firebase.google.com/docs/firestore/query-data/listen#listen_to_multiple_documents_in_a_collection
      userCartCollection
        .where("tableQR", "==", selectedQR)
        .onSnapshot(querySnapshot => {
          let cart = [...$store.state.cart];
          let sharedUserCart = [];

          querySnapshot.forEach(doc => {
            let item = { id: doc.id, ...doc.data() };
            sharedUserCart.push(item);

            let itemInCart = cart.find(x => x.id === item.id);
            if (this.shouldIRemoveItemToCart(itemInCart, item)) {
              const order = this.getOrder(item, itemInCart.size);
              $store.commit("removeOneFromCart", {
                order: order,
                size: itemInCart.size,
                update: false
              });
            } else if (this.shouldIAddItemToCart(itemInCart, item)) {
              $store.commit("addToCart", {
                item: item,
                update: false
              });
            } else if (!itemInCart) {
              $store.commit("addToCart", {
                item: item,
                update: false
              });
              $store.dispatch("addStripeProductToCart", item);
            }
          });

          if (sharedUserCart.length === 0) {
            $store.commit("removeAllCart");
            return;
          }

          cart.forEach(item => {
            let found = sharedUserCart.find(x => x.id === item.id);
            if (!found) {
              const order = this.getOrder(item, item.size);
              $store.commit("removeOneFromCart", {
                order: order,
                size: item.size,
                update: false
              });
            }
          });
        });
    },
    shouldIRemoveItemToCart(itemInCart, item) {
      return itemInCart && itemInCart.quantity > item.quantity;
    },
    shouldIAddItemToCart(itemInCart, item) {
      return itemInCart && itemInCart.quantity < item.quantity;
    },
    qrIsValid(qr) {
      return this.$store.getters.getQR(qr) !== undefined;
    },
    closeQrValidationModal() {
      this.$emit("closeQrValidationModal");
    },
    setTableNoQR() {
      let currentRouteName = this.$route.name;
      if (
        currentRouteName !== ROUTE_RECEIPT &&
        currentRouteName !== ROUTE_RECENT
      ) {
        this.isAdmin
          ? this.$store.commit("setAdminTableQR", NO_QR)
          : this.$store.commit("setTableQR", NO_QR);
      }
    }
  }
};
</script>

<style>
@media screen and (max-width: 414px) {
  .v-dialog > .v-card > .v-card__text {
    padding: 0 15px 20px !important;
  }
}
</style>
